import api from './api';
import { ENDPOINTS } from '../utils/constants';
import { formatApiError, logError } from '../utils/errorHandler';

export const getEmployeeGrainVarieties = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    if (params.search) searchParams.append('search', params.search);
    if (params.page) searchParams.append('page', params.page);
    if (params.ordering) searchParams.append('ordering', params.ordering);

    const qs = searchParams.toString();
    const url = qs
      ? `${ENDPOINTS.GRAIN_VARIETIES.EMPLOYEE.LIST}?${qs}`
      : ENDPOINTS.GRAIN_VARIETIES.EMPLOYEE.LIST;

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    logError('Get employee grain varieties', error);
    throw formatApiError(error);
  }
};

export const getEmployeeGrainVariety = async (id) => {
  try {
    const response = await api.get(ENDPOINTS.GRAIN_VARIETIES.EMPLOYEE.DETAIL(id));
    return response.data;
  } catch (error) {
    logError('Get employee grain variety', error);
    throw formatApiError(error);
  }
};

export const createGrainVariety = async (data) => {
  try {
    const response = await api.post(ENDPOINTS.GRAIN_VARIETIES.EMPLOYEE.LIST, data);
    return response.data;
  } catch (error) {
    logError('Create grain variety', error);
    throw formatApiError(error);
  }
};

export const updateGrainVariety = async (id, data) => {
  try {
    const response = await api.put(ENDPOINTS.GRAIN_VARIETIES.EMPLOYEE.DETAIL(id), data);
    return response.data;
  } catch (error) {
    logError('Update grain variety', error);
    throw formatApiError(error);
  }
};

export const deleteGrainVariety = async (id) => {
  try {
    await api.delete(ENDPOINTS.GRAIN_VARIETIES.EMPLOYEE.DETAIL(id));
  } catch (error) {
    logError('Delete grain variety', error);
    throw formatApiError(error);
  }
};
